<ng-container *accessView="['CareCoordination.Write']">
  <div class="flex justify-end mb-4">
    <button
      pButton
      label="Add Referral"
      aria-label="Add Referral"
      icon="pi pi-plus"
      iconPos="left"
      type="button"
      [addReferralAction]="memberId"
      [tenantId]="tenantId"
      [readOnly]="false"
      [memberPrepopulatedData]="memberPrepopulatedData"
      (actionComplete)="onTableUpdated($event)">
    </button>
  </div>
</ng-container>

<p-table
  [value]="data"
  [columns]="cols"
  [rows]="rows"
  [totalRecords]="totalRecords"
  [sortOrder]="defaultSortOrder"
  [sortField]="defaultSortField"
  [(first)]="firstPage"
  [scrollable]="false"
  [loading]="isLoading"
  [lazy]="true"
  [paginator]="true"
  [alwaysShowPaginator]="false"
  [selection]="selectedItem"
  [lazyLoadOnInit]="false"
  (onLazyLoad)="handleLazyLoad($event)">
  <ng-template pTemplate="colgroup" let-columns>
    <colgroup>
    @for (col of columns; track $index) {
      <col [style.width]="col.width" />
    }
  </colgroup>
</ng-template>
<ng-template pTemplate="header" let-columns>
  <tr>
    @for (col of columns; track $index) {
      <th>
        {{ col.header }}
      </th>
    }
  </tr>
</ng-template>
<ng-template pTemplate="body" let-referral let-columns="columns">
  <tr [pSelectableRow]="referral">
    <td>{{ referral.referralNumber }}</td>
    <td>
      @for (reason of referral.reason; track $index) {
        <div>{{ reason }}</div>
      }
    </td>
    <td>{{ referral.createdDate | utcToLocal: 'MM/dd/yyyy hh:mm a' }}</td>
    <td>{{ referral.createdBy | userProfileCredentialsByEmail | async }}</td>
    <td>
      <div class="flex gap-2">
        <button
          type="button"
          pButton
          icon="pi pi-eye"
          label="Preview"
          [text]="true"
          aria-label="Preview Referral"
          (click)="openPreview(referral.caseManagementReferralId, referral.createdDate)"
        ></button>
        <button
          type="button"
          pButton
          icon="pi pi-download"
          label="Download"
          [text]="true"
          aria-label="Download Referral"
          [downloadReferral]="referral.caseManagementReferralId"
          [tenantId]="tenantId"
          [memberId]="memberId"
          [subscriberNumber]="memberPrepopulatedData?.subscriberNumber"
          [dateOfReferral]="referral.createdDate"
        ></button>
      </div>
    </td>
  </tr>
</ng-template>
<ng-template pTemplate="emptymessage">
  <tr>
    <td class="w-full" colspan="10">
      No records found
    </td>
  </tr>
</ng-template>
</p-table>


